import { REALM } from "./environment";

const LOGOUT_URL = `realms/${REALM}/protocol/openid-connect/logout`;

export { LOGOUT_URL };
